import { FC, useEffect, useState, useCallback } from "react";
import { UiButton } from "@ui-monorepo/index";
import styles from "./search-bar-results.module.css";
import SearchBarResultsItem from "../search-bar-results-item/search-bar-results-item";
import { MainHeaderEvents } from "../../main-header.events";
import {
  Product,
  debounce,
  useAnalytics,
  useAppNavigation,
  StoreMetadata } from
"@commons-monorepo/index";

interface SearchBarResultsProps {
  className?: string;
  products?: Product[];
  valueToSearch: string;
  locale: string;
  currency: string;
  storeMetadata: StoreMetadata;
  onSearch: (query: string) => void;
}

const SearchBarResults: FC<SearchBarResultsProps> = ({
  className,
  valueToSearch,
  products,
  onSearch,
  locale,
  storeMetadata,
  currency
}) => {
  const [logEvent] = useAnalytics({ storeMetadata });
  const [showResults, setShowResults] = useState(false);
  const navigation = useAppNavigation();

  useEffect(() => {
    if (navigation?.state === "loading") {
      setShowResults(false);
    }
  }, [navigation]);

  const handleShowAllResults = () => {
    setShowResults(false);
    onSearch(valueToSearch);
    logEvent(MainHeaderEvents.SelectShowAllResults, { source: "button" });
  };

  const logSearchNoResults = useCallback(
    debounce(() => {
      if (valueToSearch) logEvent(MainHeaderEvents.SearchNoResults);
    }, 1000),
    [valueToSearch]
  );

  useEffect(() => {
    if (!products?.length) logSearchNoResults();else
    setShowResults(true);
  }, [products]);

  return showResults ?
  <div className={`${styles.searchBarResultsWrapper} ${className}`}>
      {!!products && products.length ?
    <div className={styles.results}>
          <div className={styles.resultsCount}>
            <div className={styles.resultsText}>Resultados</div>
            <div className={styles.count}>
              {products.length} items encontrados
            </div>
          </div>
          {products.map((p, index) =>
      <SearchBarResultsItem
        locale={locale}
        currency={currency}
        key={`SearchBarResultsItem-${index}`}
        product={p}
        onClick={() => setShowResults(false)} />

      )}
          <div className={styles.buttonBox}>
            <UiButton
          isFilled
          className={styles.button}
          onClick={handleShowAllResults}>

              Ver todos los resultados
            </UiButton>
          </div>
        </div> :

    <div className={styles.noResults}>No se encontraron coincidencias</div>}

    </div> :
  null;
};

export default SearchBarResults;